export function plainTextToHtml(text) {
  return String(text ?? '')
    .replace(/(https?:\/\/[^\s<]+|mailto:[^\s<]+)/g, '<a href="$1">$1</a>')
    .replace(/\n/g, '<br>');
}
